export default class Pagination2Controller {
  constructor($element, $scope) {
    'ngInject';
    this.$element = $element;
    this.$scope = $scope;
  }

  $onInit() {
    this.pageCount = 0;
    this.page = 1;
    this.pages = [];
    this.rendering = false;

    this.$scope.$on('resetPages', () => {
      this.page = 1;
      this.render();
    });

    this.totalItems = null;
  }

  $doCheck() {
    if (!angular.isUndefined(this.total)) {
        if (this.shouldRender()) {
          this.page = 1;
          this.totalItems = this.total;
          this.render();
        }
    }
  }

  // Render only if the total has been changed to avoid
  // digest cycle bug.
  shouldRender() {
    return this.totalItems !== this.total;
  }

  getPageCount() {
    return Math.ceil(this.totalItems / this.limitPerPage);
  }

  render() {
    this.refresh();
    let pageCount = this.getPageCount();
    if (pageCount <= 1) {
      return;
    }

    let last = pageCount;

    let upperLimit, lowerLimit;
    let currentPage = lowerLimit = upperLimit = Math.min(this.page, this.totalItems);

    for (let b = 1; b < this.maxPageCount; b++) {
      if (lowerLimit > 1 ) {
        lowerLimit--;
      }
      if (b < this.maxPageCount) {
        if (upperLimit < last) {
          upperLimit++;
        }
      }
    }

    for (let i = lowerLimit; i <= upperLimit; i++) {
      let page = {
        number: i,
        label: i,
        active: i === currentPage,
      };

      this.pages.push(page);
    }

    if (this.hasPrevious()) {
      let prevPage = {
        number: this.page - 1,
        label: '<',
      };

      this.pages.unshift(prevPage);
    }

    if (this.hasNext(last)) {
      let prevPage = {
        number: this.page + 1,
        label: '>',
      };

      this.pages.push(prevPage);
    }
  }

  hasPrevious() {
    return this.page > 1;
  }

  hasNext(lastPage) {
    return this.page !== lastPage;
  }

  refresh() {
    this.pages.length = 0;
  }

  click(page) {
    this.page = +page.number;
    this.render();
    
    let offset = (this.page - 1) * this.limitPerPage;
    this.onPageClicked({ page: this.page, offset: offset});
  }
}



// WEBPACK FOOTER //
// ./client/app/shared/ui/pagination2/pagination2.controller.js